import { SupplierMessage } from '../../../../types/SupplierMessage';
import {
    SupplierSelectionItem,
    TranslatedItemsBySupplier,
} from '../../create-enquiry/hooks/useSupplierSelectionPrices.types';
import { translateProduct } from '../../create-enquiry/util/translateProduct';

interface DeriveSupplierSelectionPriceInputsProps {
    suppliers: SupplierMessage[];
    items: SupplierSelectionItem[];
    portId?: string;
    customerId?: string;
}

export const deriveSupplierSelectionPriceInputs = ({
    suppliers,
    items,
    portId,
    customerId,
}: DeriveSupplierSelectionPriceInputsProps) => {
    const translatedItemsBySupplier: TranslatedItemsBySupplier[] = [];
    const productIds = new Set<string>();
    let hasMissingVolumeForTranslatedProduct = false;

    suppliers.forEach((supplier) => {
        const translatedItems = items.map((item) => {
            const translatedProduct = item.product ? translateProduct(item.product, supplier) : undefined;

            if (translatedProduct?.baseProductId) {
                productIds.add(translatedProduct.baseProductId);
            }

            if (translatedProduct?.productId) {
                productIds.add(translatedProduct.productId);
            }

            if (translatedProduct && !item.volume) {
                hasMissingVolumeForTranslatedProduct = true;
            }

            return {
                translatedProduct,
                packType: item.packType,
                volume: item.volume,
            };
        });

        translatedItemsBySupplier.push({
            supplier,
            items: translatedItems,
        });
    });

    const hasTranslatedProduct = translatedItemsBySupplier.some(({ items }) =>
        items.some(({ translatedProduct }) => !!translatedProduct?.productId)
    );

    const shouldFetchPrices =
        !!portId &&
        !!customerId &&
        suppliers.length > 0 &&
        hasTranslatedProduct &&
        !hasMissingVolumeForTranslatedProduct;

    return {
        translatedItemsBySupplier,
        productIds: Array.from(productIds),
        shouldFetchPrices,
    };
};
